<template>
  <div
    class="bg-background-neutral-primary flex items-start space-x-2 rounded-xl px-4 py-3"
  >
    <img
      src="../../../../assets/images/gray-warning.svg"
      width="24"
      height="24"
      alt=""
    />
    <p class="text-text-neutral-tertiary text-sm font-medium">
      {{ mismatchedText }}
    </p>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    mismatchedText: string;
  }>();
</script>
